import { render } from "./BuildingDetail.vue?vue&type=template&id=08906b1e"
import script from "./BuildingDetail.vue?vue&type=script&lang=js"
export * from "./BuildingDetail.vue?vue&type=script&lang=js"

import "./BuildingDetail.vue?vue&type=style&index=0&id=08906b1e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__